import { Tooltip, TooltipProps } from "@chakra-ui/react";
import { memo } from "react";

export default memo(function ({ color, ...tooltipProps }: TooltipProps) {
  return <Tooltip bg={"theme.dark.background"} borderWidth={2} borderColor={color} color={color} {...tooltipProps} />;
});
